export default __webpack_public_path__ + "assets/images/ae5fc066ee6c76ad3a004e429d9eafae.png";